import React from 'react';
import { SettingsOutlined, HubOutlined, AutoAwesome } from '@mui/icons-material';
import { SideBarItems } from 'components/Sidebar';
import { Settings, KnowledgeGraphs, AIPrompts } from 'modules/Anamnesis';
import { AnamnesisSidebarIcon } from './AnamnesisSidebarIcon';

const buildItems = (menuKey: 'campaignKing' | 'instantUpdate' | 'anamnesis'): SideBarItems[] => [{
    path: '/',
    urlKey: 'anamnesis',
    text: 'Anamnesis',
    icon: <AnamnesisSidebarIcon />,
    type: 'menuHeader',
    menuKey,
    requiredModule: 'anamnesis.cloud',
    dictionaryKey: 'sidebar-menu-anamnesis',
    items: [
        {
            path: '/anamnesis/',
            urlKey: 'settings',
            text: 'Settings',
            icon: <SettingsOutlined />,
            type: 'menuItem',
            menuKey,
            module: <Settings />,
            requiredModule: 'anamnesis.cloud',
            requiredRole: 'admin',
            dictionaryKey: 'sidebar-menu-anamnesis-settings',
        },
        {
            path: '/anamnesis/',
            urlKey: 'knowledge-graphs',
            text: 'Knowledge Graphs',
            icon: <HubOutlined />,
            type: 'menuItem',
            menuKey,
            module: <KnowledgeGraphs />,
            requiredModule: 'anamnesis.cloud',
            dictionaryKey: 'sidebar-menu-anamnesis-knowledge-graphs',
        },
        {
            path: '/anamnesis/',
            urlKey: 'ai-prompts',
            text: 'AI Prompts',
            icon: <AutoAwesome />,
            type: 'menuItem',
            menuKey,
            module: <AIPrompts />,
            requiredModule: 'anamnesis.cloud',
            dictionaryKey: 'sidebar-menu-anamnesis-ai-prompts',
        },
    ]
}];

export const ModulesMenu: SideBarItems[] = [
    ...buildItems('campaignKing'),
    ...buildItems('instantUpdate'),
    ...buildItems('anamnesis'),
];
